export default "__VITE_ASSET__b397c95a__"